import * as React from "react";
import type { SvgIconProps } from "../types";
import { resolveA11yProps, resolveIconSize } from "../createIcon";

export function EdgeIcon(props: SvgIconProps) {
  const { size, title, ...rest } = props;
  const { width, height } = resolveIconSize(size, 13, 13);
  const a11y = resolveA11yProps(props);

  return (
    <svg viewBox="0 0 13 13" xmlns="http://www.w3.org/2000/svg" fill="none" width={width} height={height} {...rest} {...a11y}>{title ? <title>{title}</title> : null}<path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" d="M6.5 12.5a6 6 0 0 1-6-6m6 6c2.12 0 3.985-1.1 5.052-2.761-1.271.781-3.675.695-5.319-.317-1.382-.85-2.057-3.211-1.023-4.297M6.5 12.5c-3-2-3-6-1.29-7.375M.5 6.5a6 6 0 0 1 11.747-1.728C12.908 7.857 10 9 8.5 8c.37-1.478-.012-2.478-.664-3M.5 6.5C1 3 5.5 2 7.836 5m0 0A1.98 1.98 0 0 0 6.5 4.574c-.578.043-1 .247-1.29.55" /></svg>
  );
}

export default EdgeIcon;
